import Blue from "~/core";

new Blue({
	name: 'Jump Link',
	selector: ".jump-link",
	setup(jumpLink) {
        let lastKnownScrollPosition = 0;
        let ticking = false;
        document.addEventListener('scroll', function(e) {
            lastKnownScrollPosition = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(function() {
                    window.scrollY > 350 ? jumpLink.classList.add('is-active') : jumpLink.classList.remove('is-active')
                    ticking = false;
                })
                ticking = true;
            }
        });
		this.$addEvents(jumpLink, 'click.stop.prevent', function() { 
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
            })
        })
	}
});